@if (!showFollowersComparison()) {
<div class="bg-white dark:bg-surface-1 px-4 pt-6 pb-24 android:pb-36">
  <div class="flex items-start justify-between gap-3 mb-5">
    <div>
      <h1 class="text-xl font-bold text-[#141437] dark:text-white">Social Media Performance</h1>
      <p class="text-[10px] font-bold text-grey-500 dark:text-ink-soft uppercase tracking-widest mt-1">
        {{ displayStartDate() | date:'MMM dd, yyyy' }} - {{ displayEndDate() | date:'MMM dd, yyyy' }}
      </p>
    </div>

    <button
      (click)="openFilterSheet()"
      class="h-10 w-10 flex items-center justify-center bg-white dark:bg-surface-1 rounded-full border border-gray-200 dark:border-line text-blue-500 transition-all active:scale-95 shadow-sm"
    >
      <app-icon-v2 name="funnel" [size]="20"></app-icon-v2>
    </button>
  </div>

  <div class="mb-5 -mx-1">
    <ai-headlines></ai-headlines>
  </div>

  @if (view() === 'analyticsView') {
    <div id="social-mobile-analytics-filters" class="card-bg rounded-2xl p-4 mb-4 relative dark:!bg-surface-0 dark:!border-surface-0">
      <div class="flex items-start justify-between gap-3 mb-4">
        <div class="min-w-0">
          <h2 class="text-lg font-semibold text-[#141437] dark:text-white">Platform Performance</h2> 
        </div>

        <!-- Grip/Ellipsis Icon -->
        <div class="w-4 h-[22px] flex items-center justify-center shrink-0 mt-1">
          <app-icon-v2 name="GripVertical" [size]="16" customClass="text-[#7D7D93]"></app-icon-v2>
        </div>
      </div>
    <!-- Platfrom Performance section start -->
      @if (isPlatformWiseLoading()) {
        <div class="py-10 flex items-center justify-center">
          <app-individual-toaster [loaderType]="'light'"></app-individual-toaster>
        </div>
      } @else if (platformItems().length > 0) {
        <div class="relative group/tabs mb-4">
          <div
            #platformTabsContainer
            class="tabs-container"
            (scroll)="updateScrollState()" 
          >
            @for (item of platformItems(); track item.platformName) {
              <button
                #platformTabButton
                type="button"
                [attr.data-platform]="item.platformName"
                (click)="selectPlatform(item.platformName)"
                class="flex items-center gap-2 rounded-xl border px-3 py-2.5 text-sm font-medium transition-all duration-200 dark:border-line"
                [style.borderColor]="selectedPlatformName() === item.platformName ? item.accentColor : null"
                [style.background]="selectedPlatformName() === item.platformName ? item.badgeBg : null"
                [style.color]="selectedPlatformName() === item.platformName ? item.accentColor : null"
                [ngClass]="selectedPlatformName() !== item.platformName ? 'bg-white dark:bg-line text-[#38385B] dark:text-ink-soft' : ''"
              >
                <div
                  class="w-7 h-7 rounded-lg flex items-center justify-center shadow-sm"
                  [style.background]="item.badgeBg"
                >
                  <img
                    class="w-7 h-7 object-contain"
                    [src]="item.icon"
                    [alt]="item.platformName"
                    decoding="async"
                    fetchpriority="high"
                  />
                </div>
                <span class="whitespace-nowrap ">{{ item.platformName }}</span>
              </button>
            }
          </div>
        </div>

        @if (selectedPlatform(); as item) {
            
            @if (primaryPlatformStat(); as stat) {
              <div class="mb-4">
                <p class="text-sm font-medium text-[#38385B] dark:text-ink-soft">
                  {{ stat.label }}
                </p>
                <p class="text-[40px] leading-none font-bold text-[#141437] dark:text-white mt-2">
                  {{ stat.formattedValue }}
                </p>
              </div>
            }

            <div class="divide-y divide-[#EAEAEA] dark:divide-line">
              @for (stat of secondaryPlatformStats(); track stat.key) {
                <div class="flex items-center justify-between gap-3 py-3">
                  <span class="text-sm font-medium text-[#38385B] dark:text-ink-soft">
                    {{ stat.label }}
                  </span>
                  <span class="text-sm font-semibold text-[#141437] dark:text-white text-right">
                    {{ stat.formattedValue }}
                  </span>
                </div>
              }
            </div>

            <button
              type="button"
              (click)="toggleFollowersComparison()"
              class="mt-4 w-full h-[52px] px-4 flex items-center justify-between rounded-2xl border border-[#E9D5FF] dark:bg-surface-0 dark:border-line bg-white  text-[#AD46FF] font-semibold"
            >
              <span>View Overall Followers</span>
              <app-icon-v2
                name="chevronRight"
                [size]="18"
                class="text-[#000000] dark:text-white transition-transform duration-200"
                [class.rotate-90]="showFollowersComparison()"
              ></app-icon-v2>
            </button>
        }
      } @else {
        <div class="rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 p-8 text-center">
          <p class="text-base font-medium text-slate-700 dark:text-slate-200">No analytics data found</p>
          <p class="text-sm text-slate-500 dark:text-slate-400 mt-1">
            Add new stats or adjust the selected date range.
          </p>
        </div>
      }
    </div>
    <!-- Platfrom Performance section end -->
<!-- stats card data -->
      <div
        class="grid grid-cols-2 gap-4 xl:gap-3 [@media(max-height:620px)]:gap-2 mt-4 mb-4 relative">
        @if(isOverallLoading()){
        <div class="h-[135px] shadow-sm rounded-xl flex items-center justify-center col-span-2">
          <app-individual-toaster></app-individual-toaster>
        </div>
        } @if(!isOverallLoading() && mobileOverallStats().length > 0){ @for(stat of
        mobileOverallStats(); track $index){
        <div
          class="rounded-xl bg-white dark:bg-surface-0 dark:border-surface-0 border border-[#EAEAEA]  px-4 py-4 xl:px-3 xl:py-3 [@media(max-height:620px)]:px-2.5 [@media(max-height:620px)]:py-2.5 text-[#141437] dark:text-white hover:-translate-y-1 duration-300 relative shadow-sm min-h-[132px]">
          <div class="h-full flex flex-col justify-between relative">
            <div class="flex items-start justify-between gap-3">
              <button class="p-2 rounded-lg text-white self-start" [style.background]="stat.bg">
                <app-icon [size]="18" [name]="stat.icon"></app-icon>
              </button>

              <div class="w-4 h-[22px] flex items-center justify-center shrink-0 mt-1">
                <app-icon-v2 name="GripVertical" [size]="16" customClass="text-[#7D7D93]"></app-icon-v2>
              </div>
            </div>
            <div
              class="flex flex-col gap-2 xl:gap-1.5 [@media(max-height:620px)]:gap-1 pt-3">
              <span class="font-semibold text-sm xl:text-[11px] xl:leading-tight xl:whitespace-nowrap">
                {{ stat.label.includes('Watch Time') ? 'Watch Time' : stat.label }}
              </span>
              @if (stat.label.includes('Watch Time')) {
                <div class="flex items-baseline gap-1.5 flex-wrap">
                  <span class="text-2xl xl:text-xl [@media(max-height:620px)]:text-xl font-semibold">
                    {{ formatOverallStatCount(stat.count) }}
                  </span>
                  <span class="text-sm font-medium text-[#38385B] dark:text-ink-soft">(Hours)</span>
                </div>
              } @else {
                <span class="text-2xl xl:text-xl [@media(max-height:620px)]:text-xl font-semibold"> 
                  {{ formatOverallStatCount(stat.count) }} 
                </span>
              }
            </div>
          </div>
        </div>
        } }
      </div>

<!-- stats card data end -->
    

    <div class="grid grid-cols-1 gap-4">
      <div class="card-bg rounded-2xl p-4 relative dark:!bg-surface-0 dark:!border-surface-0">
        <h2 class="text-sm font-medium text-[#141437] dark:text-white">Total Watch Time Distribution</h2>
        <div class="absolute right-4 top-4 w-4 h-[22px] flex items-center justify-center shrink-0 mt-1">
          <app-icon-v2 name="GripVertical" [size]="16" customClass="text-[#7D7D93]"></app-icon-v2>
        </div>
        @if (!isDonutChartLoading() && watchTimeSummaryCards().length > 0) {
          <div class="mt-4">
            <div class="text-2xl xl:text-xl [@media(max-height:620px)]:text-xl font-semibold leading-none font-bold text-[#141437] dark:text-white">
              {{ totalWatchTimeDisplay() }}
              <span class=" ml-1">Hrs</span>
            </div>

            <div class="grid grid-cols-2 gap-4 mt-6">
              @for (item of watchTimeSummaryCards(); track item.label) {
                <div
                  class="relative rounded-[20px] border pt-6 p-4 min-h-[130px] flex flex-col items-center justify-center text-center overflow-visible transition-all duration-300"
                  [style.background]="
                  item.label === 'Facebook' && isDarkMode
                    ? 'rgba(59,130,246,0.15)'
                    : item.background
                "
                [style.borderColor]="
                  item.label === 'Facebook' && isDarkMode
                    ? 'rgba(59,130,246,0.3)'
                    : item.borderColor
                "
                  [ngClass]="item.label === 'Facebook' ? 'dark:!bg-blue-500/15 dark:!border-blue-500/30 dark:hover:shadow-lg dark:hover:shadow-blue-500/25' : ''"
                >
                  <div class="absolute -top-3 left-1/2 -translate-x-1/2 w-6 h-6 rounded-full bg-white dark:bg-surface-1 border border-[#D7DBE4] dark:border-line shadow-sm flex items-center justify-center text-xs font-semibold text-[#141437] dark:text-white">
                    {{ item.rank }}
                  </div>

                  <div class="w-10 h-10 rounded-lg bg-white dark:bg-surface-1 shadow-sm flex items-center justify-center">
                    @if (item.icon) {
                      <img
                        class="w-7 h-7 object-contain"
                        [src]="item.icon"
                        [alt]="item.label"
                        loading="lazy"
                        decoding="async"
                      />
                    } @else {
                      <span class="text-sm font-semibold" [style.color]="item.color">
                        {{ item.label.charAt(0) }}
                      </span>
                    }
                  </div>

                  <div class="mt-3 text-xs font-semibold text-[#141437] dark:text-white">
                    {{ item.label }}
                  </div>
                  <div class="mt-1 text-sm font-semibold text-[#7D7D93] dark:text-ink-soft">
                    {{ item.formattedValue }} Hrs
                  </div>
                </div>
              }
            </div>
          </div>
        } @else {
          <div class="py-10 text-center text-gray-500">
            <p class="text-base font-medium">No watch time data available</p>
          </div>
        }
      </div>

    </div>
  } @else {
    @if (isLoading()) {
      <div class="card-bg rounded-2xl p-8 text-center">
        <p class="text-slate-600 dark:text-slate-300 font-medium">Loading analytics data...</p>
      </div>
    } @else if (processedStatsData().length > 0) {
      <div class="card-bg rounded-2xl overflow-hidden">
        <div class="px-4 py-4 border-b border-slate-200/50 dark:border-slate-600/50">
          <h2 class="text-lg font-medium text-slate-800 dark:text-slate-200">
            Platform Performance Statistics
          </h2>
          <p class="text-sm text-slate-600 dark:text-slate-400 mt-1">
            {{ totalItems() }} total records found
          </p>
        </div>

        <div class="p-3">
          <app-paginated-table
            [tableData]="processedStatsData()"
            [headers]="tableHeaders()"
            [isCheckboxShow]="false"
            [tableActionOptions]="{
              showToggleButton: true,
              toggleOptions: tableActionOptions()
            }"
            (actionSelected)="requestTableAction($event)"
          />
        </div>
      </div>
    } @else {
      <div class="card-bg rounded-2xl p-8 text-center">
        <p class="text-lg font-medium text-slate-900 dark:text-slate-100">No analytics data found</p>
        <p class="text-slate-600 dark:text-slate-400 mt-2">
          There are no social platform statistics matching your current filters.
        </p>
      </div>
    }
  }
</div>
} @else if (showFollowersComparison()) {
  <div #followersComparisonSection class="bg-white dark:bg-surface-1 min-h-screen pb-6 -mt-px">
    <!-- Sticky Header -->
    <div class="sticky top-0 z-50 bg-white dark:bg-surface-1 px-4 pt-6 pb-4 border-b border-gray-100 dark:border-line shadow-sm relative">
      <button
        (click)="toggleFollowersComparison()"
        class="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full border border-gray-200 dark:border-line dark:bg-surface-1 flex items-center justify-center active:scale-95 transition-all"
        aria-label="Back"
      >
        <app-icon-v2 name="ChevronLeft" [size]="24" customClass="text-[#38385B] dark:text-white"></app-icon-v2>
      </button>
      <h2 class="text-md text-center font-bold text-[#141437] dark:text-white w-full">Followers By Platform</h2>
    </div>

    <div class="px-4 pt-6">
      @if (isDonutChartLoading()) {
        <div class="py-10 flex items-center justify-center">
          <app-individual-toaster></app-individual-toaster>
        </div>
      } @else {
        <!-- Donut chart with center value -->
        <div class="relative flex items-center justify-center">
          <!-- Wrapper sized to match the chart's max-width / height so
               the label SVG overlay scales identically to the donut. -->
          <div class="relative w-full max-w-[500px]" style="height: 280px;">
            <app-donut-chart
              [data]="donutData()"
              [showLegend]="false"
              [showPolylines]="false"
              [showValue]="false"
              [width]="320"
              [height]="280"
              [radiusScale]="0.85"
              [translateX]="0"
            >
            </app-donut-chart>

            <!-- Custom percentage labels: shares the chart's viewBox so
                 it scales together with the donut. We compute and
                 re-project each label in donutLabels() to keep the
                 anchor outside the donut ring even after vertical
                 relaxation of clustered small slices. -->
            @if (donutLabels().length > 0) {
              <svg
                class="absolute inset-0 w-full h-full pointer-events-none overflow-visible"
                [attr.viewBox]="donutChartViewBox"
                preserveAspectRatio="xMidYMid meet"
                aria-hidden="true"
              >
                <g [attr.transform]="donutChartCenterTransform">
                  @for (label of donutLabels(); track $index) {
                    <text
                      [attr.x]="label.x"
                      [attr.y]="label.y"
                      [attr.fill]="label.color"
                      [attr.text-anchor]="label.isRight ? 'start' : 'end'"
                      dy="0.35em"
                      font-size="14"
                      font-weight="bold"
                    >{{ label.text }}</text>
                  }
                </g>
              </svg>
            }
          </div>

          <div class="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
            <span class="text-2xl lg:text-3xl font-bold text-[#141437] dark:text-white">{{ totalFollowers() }}</span>
            <span class="text-xs lg:text-sm font-medium text-[#7D7D93] dark:text-ink-soft mt-1">Total Followers</span>
          </div>
        </div>

        <!-- Platform follower list -->
        <div class="mt-6 divide-y divide-[#EAEAEA] dark:divide-line">
          @for (item of followersByPlatformList(); track item.label) {
            <div class="flex items-center justify-between py-4">
              <div class="flex items-center gap-3">
                @if (item.icon && isBrandTileIcon(item.label)) {
                  <!-- Icon SVG already includes the brand-coloured rounded tile,
                       so render it directly without the duplicate background wrapper. -->
                  <img
                    class="w-10 h-10 object-contain"
                    [src]="item.icon"
                    [alt]="item.label"
                    loading="lazy"
                    decoding="async"
                  />
                } @else {
                  <div
                    class="w-10 h-10 rounded-lg flex items-center justify-center shadow-sm"
                    
                  >
                    @if (item.icon) {
                      <img
                        class="w-10 h-10 object-contain"
                        [src]="item.icon"
                        [alt]="item.label"
                        loading="lazy"
                        decoding="async"
                      />
                    } @else {
                      <span class="text-sm font-semibold" [style.color]="item.color">
                        {{ item.label.charAt(0) }}
                      </span>
                    }
                  </div>
                }
                <span class="text-base font-medium text-[#141437] dark:text-white">{{ item.label }}</span>
              </div>
              <span class="text-base font-semibold text-[#141437] dark:text-white">{{ item.formattedValue }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
}